import BaseEventCard from './_base-event-card.js'
import Image from './_image.js'

export default {
  name: 'BannerCard',
  values: {
    eventCard: {
      configSet: BaseEventCard,
      configValues: {
        container: {
          style: {
            padding: 0,
            overflow: 'hidden',
            justifyContent: 'center',
          },
        },
        clickableArea: {
          enableAHref: true,
        },
      },
    },
    bannerImage: {
      configSet: Image,
      configValues: {
        style: {
          objectFit: 'cover',
          width: '100%',
          minHeight: '100%',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
